import { IApiUserGroupParams, IBalance } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { createNotifyingQueryFn } from 'store/utils/createNotifyingQueryFn';
import { web3Api } from 'store/queries';

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchBalance },
  useFetchBalanceQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchBalance: build.query<IBalance, IApiUserGroupParams>({
      queryFn: createNotifyingQueryFn(async ({ group }) => {
        const api = MultiService.getService().getAccountingGateway();

        const data = await api.getAnkrBalance({ group });

        return { data };
      }),
    }),
  }),
  overrideExisting: true,
});
